export const COMMODITY_CONDITIONS_LIST_PATH = '/commodity-conditions-center';

export const commodityConditionPath = (id?: string) => `${COMMODITY_CONDITIONS_LIST_PATH}/${id ?? 'new'}`;
